import CreateSetupBackend from "../config/config.js";
import { isMutual } from "../../utils/isMutual.jsx";

let SetupBackend = null;

function normalizeKeysResponse(data) {
  const candidates = [
    data?.data,
    data?.body?.data,
    data?.body?.keys,
    data?.body?.listKeys,
    data?.keys,
  ];

  const keys = candidates.find((candidate) => Array.isArray(candidate)) || [];

  return keys.map((item) => {
    const rawType = (item?.keyType || item?.type || "").toUpperCase();
    return {
      key: item?.key || item?.pixKey || item?.keyValue || "",
      keyType: rawType === "EVP" ? "RANDOM" : rawType,
      keyId: item?.keyId || item?.id || "",
      status: item?.status || "",
    };
  });
}

function create(data) {
  SetupBackend = CreateSetupBackend();

  if (isMutual()) {
    const email = sessionStorage.getItem("emailUser");
    const inputType = (data?.keyType || data?.type || "").toUpperCase();
    const type = inputType === "EVP" ? "RANDOM" : inputType;

    const payload =
      type === "RANDOM" ? { type: "RANDOM" } : { type, key: data?.key || "" };

    return SetupBackend.post(`/v1/baas/accounts/keys?email=${email}`, payload);
  }

  return SetupBackend.post("/v1/pix/keysmanagement/create", data);
}

function destroy(data) {
  SetupBackend = CreateSetupBackend();

  if (isMutual()) {
    const email = sessionStorage.getItem("emailUser");
    const keyId = data?.keyId || data?.id;

    if (!keyId) {
      throw new Error("keyId is required to delete a Pix key");
    }

    return SetupBackend.delete(
      `/v1/baas/accounts/keys/${keyId}?email=${email}`,
    );
  }

  const body = {
    account: sessionStorage.getItem("account"),
  };

  return SetupBackend.delete(`/v1/pix/keysmanagement/destroy/${data.key}`, {
    data: body,
  });
}

function index() {
  SetupBackend = CreateSetupBackend();

  if (isMutual()) {
    const email = sessionStorage.getItem("emailUser");
    return SetupBackend.get(`/v1/baas/accounts/keys?email=${email}`).then(
      (res) => ({
        ...res,
        data: normalizeKeysResponse(res?.data),
      }),
    );
  }

  return SetupBackend.get(
    `/v1/accountmanager/showpixkey?email=${sessionStorage.getItem("emailUser")}`,
  );
}

const backendServices = {
  create,
  destroy,
  index,
};

export default backendServices;
